import { useEffect, useState } from "react";
import FullListElements from "../../components/FullListElements/FullListElements";
import { PlayerWithCount } from "../../services/shirts/types";
import { ItemListElement } from "../../components/SortedItemsList/SortedItemsList";
import defaultAvatarImg from "../../img/defaultProfile.jpg";
import TopService from "../../services/topService";
import { CircularProgress } from "@mui/material";
import FormatService from "../../services/formatService";
import { useNavigate } from "react-router-dom";

const TopPlayers = () => {
  const title = "All players";

  const [topPlayers, setTopPlayers] = useState<
    Array<PlayerWithCount> | undefined
  >(undefined);
  const [teamsProcessed, setTeamsProcessed] = useState<
    Array<ItemListElement> | undefined
  >(undefined);
  const [lastPage, setLastPage] = useState<number>(0);
  const [totalElements, setTotalElements] = useState<number>(0);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);

  const { getTopPlayers } = TopService();
  const { getPlayerName } = FormatService();

  const navigate = useNavigate();

  const search = (page: number) => {
    getTopPlayers(10, page).then((result) => {
      if (result) {
        setTopPlayers(result.data as Array<PlayerWithCount>);
        setLastPage(result.lastPage);
        setTotalElements(result.total);
      }
    });
  };

  const renderValue = (value: number) => {
    return String(value) + " shirts";
  };

  const goToResults = (id: string | number) => {
    navigate("/shirts-collections/player/" + id);
  };

  useEffect(() => {
    getTopPlayers(10, 1).then((result) => {
      if (result) {
        setTopPlayers(result.data as Array<PlayerWithCount>);
        setLastPage(result.lastPage);
        setTotalElements(result.total);
      }
    });
  }, []);

  useEffect(() => {
    if (topPlayers) {
      let playerItems: Array<ItemListElement> = [];
      topPlayers.forEach((player) => {
        playerItems.push({
          id: player.id,
          name: getPlayerName(player),
          value: player.appearances,
          img: player.picture,
        });
      });
      setTeamsProcessed(playerItems);
    }
  }, [topPlayers]);

  return teamsProcessed ? (
    <FullListElements
      elements={teamsProcessed}
      title={title}
      defaultAvatarImg={defaultAvatarImg}
      searchByPage={search}
      renderValue={renderValue}
      lastPage={lastPage}
      totalElements={totalElements}
      handleOnClick={goToResults}
      itemsPerPage={itemsPerPage}
      setItemsPerPage={setItemsPerPage}
    />
  ) : (
    <CircularProgress />
  );
};

export default TopPlayers;
